import { Box, Flex, Spinner, NotFoundPage, DropdownOptions, TooltipPopup } from 'dash-ui';
import { useNavigate, useParams } from 'react-router-dom';

import PropertyDetailsHeader from 'pages/properties/PropertyDetailsPage/components/PropertyDetailsHeader/PropertyDetailsHeader';
import PropertyDetailsTabs from 'pages/properties/PropertyDetailsPage/components/PropertyDetailsTabs/PropertyDetailsTabs';
import { useGetPropertyByIdQuery } from 'gql/generated.graphql';
import { RoutesPath } from 'flow-components/routes/routes';
import Header from 'flow-components/Header/Header';
import Container from 'flow-components/Container/Container';
import renderBranch from 'common/helpers/renderBranch';

function PropertyDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, loading } = useGetPropertyByIdQuery({
    variables: { propertyId: id },
  });
  const property = data?.getPropertyById;

  if (loading) {
    return <Spinner size={32} fullContent />;
  }

  if (!property) {
    return (
      <Box h="100%">
        <NotFoundPage onRedirect={() => navigate(RoutesPath.Home)} />
      </Box>
    );
  }

  return (
    <Box h="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Header />
      <Container stickyBreadcrumbs>
        <Flex flexDirection="column" flex={1} w="100%">
          <Box w="100%" h="100%" pos="relative">
            {renderBranch(
              loading,
              <Spinner size={32} fullContent />,
              <>
                <PropertyDetailsHeader property={property} />
                <PropertyDetailsTabs property={property} />
              </>
            )}
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}

export default PropertyDetailsPage;
